// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602230804/js/" + chunkId + "." + {"44":"bef5071f","225":"0ff5d48c","481":"65decfa9","486":"f54a0473","770":"67b48066"}[chunkId] + ".0.7050669856681568.chunk.js";
};